import { InputHTMLAttributes } from 'react';
import { useFormContext, RegisterOptions } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { TextareaWrapper } from './styles';

interface IProps extends  Pick<InputHTMLAttributes<HTMLInputElement>, 'maxLength'> {
	name: string;
	registerOptions?: RegisterOptions;
	placeholder?: string;
	label?: string;
	labelVisibility?: boolean;
	className?: string;
	value?: string;
	disabled?: boolean;
	defaultValue?: string;
	onChange?: (value: string) => void;
}

export function Textarea({
	name,
	registerOptions,
	placeholder,
	label,
	labelVisibility = true,
	className,
	value,
	defaultValue,
	disabled = false,
	onChange,
	maxLength
}: IProps) {
	const { register, formState } = useFormContext();
	const { errors } = formState;

	// onChange Handler
	const onChangeHandler = (Event: any) => {
		const element = { ...(register && { ...register(`${name}`, registerOptions) }) };
		if (Object.keys(element).length !== 0) element.onChange(Event);
		if (onChange) onChange(Event);
	};

	return (
		<TextareaWrapper  className={className}>
			<div className='label'>
				{label && (
					<p>
						{label} {registerOptions?.required && <span>*</span>}
					</p>
				)}
				<textarea
					placeholder={placeholder}
					{...register(name, registerOptions)}
					value={value}
					disabled={disabled}
					defaultValue={defaultValue}
					onChange={onChangeHandler}
					className={`${errors[name] ? 'hasError' : ''}`}
					maxLength={maxLength}
				/>
				{/* <MantineTextarea  placeholder={placeholder} {...register(name, registerOptions)} /> */}
			</div>
			{!!errors && !!errors[name] && (
				<div className="ErrorMessageStyle">
					<ErrorMessage errors={errors} name={name} render={({ message }) => <p>{message}</p>} />
				</div>
			)}
		</TextareaWrapper>
	);
}

